module.exports = __webpack_public_path__ + "img/LOGO.547cfaa1.png";